'use client'

import { useContext } from 'react'
import type { Product } from '@productsite-beta/src/graphql/generated/graphql-types'
import { AttachedSalesContext } from '../../../product-context/attached-sales-provider'
import ProductCard from '../product-add-ons/product-card/product-card'

type Props = {
  product: Product
  ticket: string
  isMobile: boolean
}

const ProductCommonChargerCard = ({ product, ticket, isMobile }: Props) => {
  const { handleIsSelected, list } = useContext(AttachedSalesContext)

  const attachedItem = list.find(
    item => item.productErpIdentifier === product.productErpIdentifier
  )
  const isSelected = attachedItem?.isSelected ?? false

  const handleCheckbox = () => {
    handleIsSelected(product.productErpIdentifier)
  }

  return (
    <ProductCard
      product={product}
      ticket={ticket}
      isSelected={isSelected}
      isSmallScreen={isMobile}
      handleCheckbox={handleCheckbox}
      digitalDataOrigin="productPageRecommendedCharger"
      digitalIndex={0}
    />
  )
}

export default ProductCommonChargerCard
